import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class GroupRoleInUseError extends CodedError {
  static get errorName() {
    return errorCodes.groupRoleInUseError.code;
  }

  constructor(message: string = errorCodes.groupRoleInUseError.message) {
    super(message);
    this.code = errorCodes.groupRoleInUseError.code;
    this.message = `${message} ${errorCodes.groupRoleInUseError.code}`;
    this.name = errorCodes.groupRoleInUseError.name;
  }
}
